import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
} from "@mui/material";
import Image1 from "../../assets/nw/1.jpg";
import Image2 from "../../assets/nw/2.jpg";
import Image3 from "../../assets/nw/1-05.webp";
import Image4 from "../../assets/nw/4.jpg";

const MakeTheSwitch = () => {
  const cardContents = [
    {
      number: 1,
      image: Image1,
      heading: "Book a Free Site Visit",
      description:
        "Explore Kalpavruksha Green by scheduling a free site visit. Experience lush surroundings, planned plots, and eco-friendly design — the perfect investment for your future.",
    },
    {
      number: 2,
      image: Image2,
      heading: "Plot Measurement & Guidance",
      description:
        "Our experts provide plot measurements, layout insights, and transparent cost details to help you make an informed decision with confidence.",
    },
    {
      number: 3,
      image: Image3,
      heading: "Project Development & Progress",
      description:
        "Kalpavruksha Green features premium infrastructure, wide roads, underground cabling, and green zones — blending modern comfort with natural living.",
    },
    {
      number: 4,
      image: Image4,
      heading: "Handover & Quality Assurance",
      description:
        "Each plot undergoes inspection and quality checks before handover, ensuring top standards, excellence, and lasting value for every homeowner.",
    },
  ];

  return (
    <div
      xs={12}
      sm={4}
      md={4}
      style={{
        padding: "30px",
        height: { xs: "500px", md: "200px" },
        borderBottom: "1px solid #ccc",
        background:
          "linear-gradient(to right, rgba(226, 255, 255, 0.26), rgba(0, 180, 194, 0.16))",
      }}
    >
      <Grid
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingBottom: { xs: "0", sm: "10px", md: "20px" },
        }}
      >
        <Grid
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            // gap: "13px",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              width: "100%",
              fontWeight: "600",
              fontSize: { xs: "20px", sm: "25px", md: "28px" },
              lineHeight: "36px",
              color: "#333333",
              textAlign: "center",
            }}
          >
            Your Journey to Kalpavruksha Green
          </Typography>

          <Typography
            variant="body1"
            sx={{
              width: "100%",
              fontWeight: "500",
              fontSize: { xs: "12px", sm: "14px", md: "16px" },
              lineHeight: { xs: "24px", sm: "28px", md: "30px" },
              color: "#666666",
              textAlign: "center",
              mt: 1,
            }}
          >
            Discover how easy it is to own your dream plot at Kalpavruksha Green
            — where modern living meets nature’s serenity.
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        {cardContents.map((card, index) => (
          <Grid item xs={12} md={3} key={index}>
            <Card sx={{ height: "100%", position: "relative" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100px",
                  mt: 2,
                }}
              >
                <img
                  src={card.image}
                  alt="Image"
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
              </Box>
              <CardContent sx={{ textAlign: "center" }}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {card.heading}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ marginTop: 2, textAlign: "center" }}
                >
                  {card.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default MakeTheSwitch;
